import { isAsianWorld,asianTileNames } from './asianWorlds.ts'
import { parisTileNames } from './parisLayout.ts'
import { isEuropeanWorld, europeanTileNames } from './europeanWorlds.ts'
import { mexicoTileNames } from './mexicoCityLayout.ts'
export const worlds = [
  {id:'new-york',name:'New York',place:'United States',ready:true},
  {id:'las-vegas',name:'Las Vegas',place:'United States',ready:true},
  {id:'mexico-city',name:'Mexico City',place:'Mexico',ready:true},
  {id:'paris',name:'Paris',place:'France',ready:true},
  {id:'munich',name:'Munich',place:'Germany',ready:true},
  {id:'moscow',name:'Moscow',place:'Russia',ready:true},
  {id:'venice',name:'Venice',place:'Italy',ready:true},
  {id:'beijing',name:'Beijing',place:'China',ready:true},
  {id:'seoul',name:'Seoul',place:'South Korea',ready:true},
  {id:'tokyo',name:'Tokyo',place:'Japan',ready:true},
  {id:'sao-paulo',name:'São Paulo',place:'Brazil',ready:false},
  {id:'new-delhi',name:'New Delhi',place:'India',ready:false},
  {id:'jakarta',name:'Jakarta',place:'Indonesia',ready:false},
  {id:'hanoi',name:'Hanoi',place:'Vietnam',ready:false},
  {id:'klavius',name:'Klavius',place:'Moon',ready:false},
  {id:'solara',name:'Solara',place:'Mars',ready:false},
  {id:'atlantis',name:'Atlantis',place:'Oceana',ready:false},
  {id:'cairo',name:'Cairo',place:'Egypt',ready:false},
  {id:'istanbul',name:'Istanbul',place:'Turkey',ready:false},
  {id:'barcelona',name:'Barcelona',place:'Spain',ready:false},
] as const

export type WorldId = typeof worlds[number]['id']
export type ReadyWorldId = 'new-york' | 'las-vegas' | 'mexico-city' | 'paris' | 'munich' | 'moscow' | 'venice' | 'beijing' | 'seoul' | 'tokyo'

export function selectedWorld(id: string | undefined): ReadyWorldId {
  const world=worlds.find(world=>world.id===id)
  return world?.ready ? world.id as ReadyWorldId : 'new-york'
}

export function currentWorld(id: string | undefined) {
  return worlds.find(world => world.id === selectedWorld(id))!
}

// Board index stays stable across cities, preserving rolls, houses, and challenges.
// Only the visible address changes when a player switches worlds.
const vegasNames: Record<number,string> = {
  0:'WELCOME',1:'FREMONT ST',3:'OGDEN AVE',4:'CITY TAX',5:'MONORAIL',6:'MAIN ST',8:'CARSON AVE',9:'BONANZA RD',
  10:'DESERT PARK',11:'SAHARA AVE',13:'CHARLESTON BLVD',14:'LAS VEGAS BLVD',15:'MONORAIL',
  16:'SPRING MTN RD',18:'FLAMINGO RD',19:'PARADISE RD',20:'NEON FESTIVAL',21:'TROPICANA AVE',
  23:'HARMON AVE',24:'KOVAL LN',25:'MONORAIL',26:'RUSSELL RD',27:'SUNSET RD',29:'WARM SPRINGS',
  30:'RED ROCK',31:'RAINBOW BLVD',33:'BUFFALO DR',34:'DURANGO DR',35:'MONORAIL',
  36:'DECATUR BLVD',38:'FORT APACHE',39:'SHIELD',
}
export const tileNameForWorld = (worldId:string|undefined,index:number,defaultName:string) =>
  isAsianWorld(worldId) ? (asianTileNames(worldId)[index] ?? defaultName) : isEuropeanWorld(worldId) ? (europeanTileNames(worldId)[index] ?? defaultName) : selectedWorld(worldId)==='las-vegas' ? (vegasNames[index] ?? defaultName) : selectedWorld(worldId)==='mexico-city' ? (mexicoTileNames[index] ?? defaultName) : selectedWorld(worldId)==='paris' ? (parisTileNames[index] ?? defaultName) : defaultName

export { vegasLandmarks } from './lasVegasLayout.ts'

export const vegasIntro = 'A palm-lined boulevard, spectacular resorts, and the lights of Downtown.'

export { mexicoLandmarks } from './mexicoCityLayout.ts'
export const mexicoIntro = 'From Reforma and the historic center to Chapultepec’s gardens and Xochimilco’s canals.'

export { parisLandmarks } from './parisLayout.ts'
export const parisIntro = 'Along the Seine, through limestone boulevards, and up to the domes of Montmartre.'
